export default __webpack_public_path__ + "static/media/reactLogo.d1d00361.png";